export const en = {
  selectPerson: 'Select Person',
  teamCounter: '%(teamCounter)s %(subject)s',
  teamCounterSubject: 'Member',
}

export const es = en
